module.exports = __webpack_public_path__ + "media/title_mob_1.850f353d.mp4";